// Reusable empty-state with friendly illustration (Lucide icon on cream disc) + CTA.
import { Button } from "@/components/ui/button";
import { Sparkles } from "lucide-react";
import { useLanguage } from "@/App";

export default function EmptyState({ icon: Icon = Sparkles, title_ar, title_en, body_ar = "", body_en = "", cta_ar, cta_en, onCta, secondaryCtaAr, secondaryCtaEn, onSecondary, testid = "empty-state" }) {
  const { t } = useLanguage();
  return (
    <div className="card-soft p-8 sm:p-12 text-center space-y-5 max-w-xl mx-auto animate-fade-in" data-testid={testid}>
      <div className="mx-auto w-28 h-28 rounded-full bg-cream relative grid place-items-center" style={{boxShadow: "var(--shadow-gold)"}}>
        <div className="absolute inset-2 rounded-full border-2 border-dashed" style={{borderColor: "var(--accent-gold-soft)"}} />
        <Icon size={40} className="text-gold" style={{color: "var(--accent-gold)"}} />
        <span className="absolute -top-1 -right-1 w-6 h-6 rounded-full bg-white grid place-items-center shadow"><Sparkles size={12} style={{color: "var(--accent-gold)"}} /></span>
      </div>
      <h3 className="text-xl sm:text-2xl font-bold" style={{color: "var(--text-primary)"}}>{t(title_ar, title_en)}</h3>
      {(body_ar || body_en) && <p className="text-sm" style={{color: "var(--text-secondary)"}}>{t(body_ar, body_en)}</p>}
      <div className="flex flex-wrap justify-center gap-2 pt-2">
        {cta_ar && (
          <button onClick={onCta} className="btn-primary inline-flex items-center gap-2" data-testid={`${testid}-cta`}>
            <Sparkles size={14} /> {t(cta_ar, cta_en)}
          </button>
        )}
        {secondaryCtaAr && (
          <button onClick={onSecondary} className="btn-secondary" data-testid={`${testid}-secondary`}>{t(secondaryCtaAr, secondaryCtaEn)}</button>
        )}
      </div>
    </div>
  );
}
